import axios from 'axios'
// const url = 'http://34.80.198.150:7777/api/'
const url =
  process.env.NODE_ENV === 'production'
    // ? process.env.API_HOST
    ? 'https://server.ezwash.com.tw/'
    : 'http://localhost:1688/'

const api = {
  createOrder: url + 'addOreder',
  getOrderList: url + 'order/getAll',
  remittance: url + 'order/remittance',
  couponList: url + 'couponList',
  getHoliday: url + 'holiday',
  
}

export function createOrder (params) {
  return axios.post(api.createOrder, params)
}

export function getOrder (params) {
  return axios.post(api.getOrderList, params)
}

export function getHoliday (params) {
  return axios.get(api.getHoliday, params)
}

export function remittance (params) {
  return axios.post(api.remittance, params)
}

export function couponList (params) {
  return axios.post(api.couponList, params)
}
